import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../../axios.config'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: 'Baba Bo',
    barang: [],
    editData:'',
    isLogin:false,
    simpanEditIndex:''
  },
  mutations: {
    listBarang (state, payload) {
      state.barang = payload
    },
    deleteBarang(state, index){
      state.barang.splice(index,1)
    },
    editData(state,data){
      state.editData = data
      console.log(state.editData,'dari mutations edit data')
    },
    logOut(state){
      state.isLogin = false
    },
    login(state){
      state.isLogin = true
    },
    simpanEditIndex(state,index){
      state.simpanEditIndex = index
    },
    editProduct(state,data){
      console.log(state.simpanEditIndex,`dari mutasi`)
      state.barang.splice(state.simpanEditIndex,1)
      state.barang.push(data)
    }
  },
  actions: {
    fetchData (context) {
      const result = []
      axios({
        method: 'get',
        url: '/product'
      })
        .then(data => {
          for (let i = 0; i < data.data.length; i++) {
            result.push(data.data[i])
          }
          console.log(result)
          context.commit('listBarang',result)
        })
        .catch(err => {
          console.log(err)
        })
    },
    deleteProduct (context,data){
      let {id, index} = data
      console.log(data)
      axios({
        method: 'delete',
        url: `/product/${id}`,
        headers:{
          token: localStorage.token
        }
      })
        .then(data => {
          // console.log(data,`dari delete product`)
          context.commit('deleteBarang', index)
        })
        .catch(err => {
          console.log(err)
        })
    },
    findOne(context,id){
      console.log(id,'dari id findOne')
      axios({
        method: 'get',
        url: `/product/${id}`
      })
        .then(data => {
          console.log(data,'dari data findOne')
          let editData ={
            name: data.data.name,
            price: data.data.price,
            image_url: data.data.image_url,
            stock: data.data.stock  
          }
          context.commit('editData',editData)
          
        })
    },
    editProduct (context, data) {
      let {name, image_url, price, stock, id} = data
        axios({
        method: 'put',
        url: `/product/${id}`,
        data: {
          name,
          price,
          image_url,
          stock
        },
        headers:{
          token: localStorage.token
        }
      })
        .then(data => {
          console.log(data.data,'dari edit product index')
          context.commit('editProduct',data.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    logOut (context) {
      localStorage.clear()
      context.commit('logOut')
    },
    login (context, payload) {
      let {email, password} = payload
      axios({
        method: 'post',
        url: '/login',
        data: {
          email, password
        }
      })
        .then(data => {
          localStorage.setItem('token', data.data.token)
          console.log(localStorage.token)
          context.commit('login')
          Swal.fire({
            title: 'Welcome',
            text: `Sukses Login`,
            icon: 'success'
          })
          router.push({name:'AllProduct'})
        })
    },
    simpanEditIndex (context, index) {
      context.commit('simpanEditIndex',index)
    },
    addProduct (context, data){
      let {name, image_url,price,stock} = data
      axios({
        method: 'post',
        url:'/product',
        data: {
          name,
          image_url,
          price,
          stock
        },
        headers: {
          token: localStorage.token
        }
      })
        .then(data => {
          if(data !== undefined){
            Swal.fire({
              title: 'Sukses Add',
              text: `Nice..`,
              icon: 'success'
            })
            router.push({name:'AllProduct'})
          }
        })
    }
  },
  getters: {
  }
})
